import { Timespan } from '@thingslog/repositories';
import { format, subMonths } from 'date-fns';

export const createDefaultPredefinedTimespan = (): Timespan => ({
  type: 'predefined',
  name: 'this-month',
});

export const createDefaultCustomTimespan = (): Timespan => {
  const today = new Date();

  return {
    type: 'custom',
    fromDate: format(subMonths(today, 1), 'yyyy-MM-dd'),
    toDate: format(today, 'yyyy-MM-dd'),
  };
};
